import asset from "./asset/asset.js";
import category from "./asset/category.js";
import location from "./asset/location.js";
import report from "./asset/report.js";
import common from "./asset/common.js";

export default {
    asset,
    category,
    location,
    report,
    common
};